import React, { Fragment, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Form,
  Row,
  Col,
} from "reactstrap";
import DataTable from "react-data-table-component";
import SweetAlert from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { H3, Btn, Breadcrumbs, H4 } from "../../../AbstractElements";
import {
  Search,
  Filter,
  Export,
  Import,
  Enquiry,
  EnquiryList,
  newEnquiry,
  
} from "../../../Constant";

import { deleteEnquiry, getStaff, leadsCounts, showLead } from "../../../CommonURL";

import {
  getDataWithToken,
  getClientUrlDataToken,
  postDataWithToken,
} from "../../../Utils/restUtils";

import Transparentspinner from "../../Common/loader/Transparentspinner";
import { toast } from "react-toastify";
import { leadsColumns } from "../CloumnHeader/Header";
import Widgets from "../../Common/Progress/Widgets";

const LeadList = () => {
  const navigate = useNavigate();
  const authState = useSelector((state) => state.auth);

  const [spinnerTrans, setspinnerTrans] = useState(false);

  const [customerLists, setCustomerList] = useState([]);
  const [users, setUsers] = useState([]);
  const [itemOption, setitemsoptions] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [importDrpodown, setimportDrpodown] = useState(false);

  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");

  const [isStatus, setIsStatus] = useState("");
  const [tempStatus, setTempStatus] = useState("");

  const [isUser, setIsUser] = useState("");
  const [tempUser, setTempUser] = useState("");

  const [staticwidgets, setstaticwidgets] = useState([])
  
  const [isProduct, setIsProduct] = useState("");
  const [tempProduct, setTempProduct] = useState("");

  const [dateRange, setDateRange] = useState([null, null]);
  const [tempDateRange, setTempDateRange] = useState([null, null]);

  const [startDate, endDate] = dateRange;
  const [tempStartDate, tempEndDate] = tempDateRange;

  const [sortConfig, setSortConfig] = useState({
    column: "",
    order: "",
  });

  const formatStartDate = startDate
    ? moment(startDate).format("DD-MM-YYYY")
    : "";

  const formatEndDate = endDate ? moment(endDate).format("DD-MM-YYYY") : "";

  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  const enquiryStatusOptions = [
    { label: "Prospect", value: "prospect" },
    { label: "Negotiation", value: "negotiation" },
    { label: "Won", value: "won" },
    { label: "Lost", value: "lost" },
  ];
  useEffect(() => {
    fetchLeads(currentPage);
  }, [
    currentPage,
    perPage,
    searchKeyword,
    isStatus,
    isUser,
    isProduct,
    sortConfig,
    formatStartDate,
    formatEndDate,
  ]);
  useEffect(() => {
    userData();
    getwidgetsdata()
  }, []);

  const fetchLeads = async (page = currentPage, size = perPage) => {
    setspinnerTrans(true);

    try {
      const response = await getDataWithToken(
        `${showLead}?page=${page}
      &page_length=${size}
      &search=${searchKeyword || ""}
      &stage=${isStatus || ""}
      &user_id=${isUser || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}
      &product_id=${isProduct || ""}`,
      );

      if (response?.status === true) {
        setResetPaginationToggle(!resetPaginationToggle);

        const SerialNo = (page - 1) * size + 1;

        setCustomerList(
          response?.data?.data?.map((e, index) => ({
            Si: SerialNo + index,
            name: e.name || "N/A",
            Mobile: e?.phone || "N/A",
            product: e?.product_name || "N/A",
            Status: e.stage || "N/A",
            created: e?.created_at || "N/A",
            nextFollowup: e?.next_followup_date || "N/A",
            assigned: e?.assigned_user_name || "N/A",
            leadId: e?.lead_id || "N/A",
            expectedValue: e?.expected_value || "N/A",
            id: e?.id,
          })),
        );

        setTotalRows(response?.data?.total);
      }
    } finally {
      setspinnerTrans(false);
    }
  };
  const userData = async () => {
    const data = await getDataWithToken(getStaff);

    if (data.status === true) {
      setUsers(data.data.data);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault();

    setSearchKeyword(tempSearch);
    setIsStatus(tempStatus);
    setIsUser(tempUser);
setDateRange(tempDateRange);
    setCurrentPage(1);
  };
  const handleSort = (column) => {
    let newOrder = "asc";

    if (sortConfig.column === column.id) {
      newOrder = sortConfig.order === "asc" ? "desc" : "asc";
    }

    setSortConfig({
      column: column.id,
      order: newOrder,
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };
  
  const getwidgetsdata = async () => {
    const data = await getDataWithToken(leadsCounts);
    if (data.status === true) {
      setstaticwidgets(data.data);
    } else {
      handleApiError(data.status);
    }
  }

  const toggleImport = () => setimportDrpodown(!importDrpodown);

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

const exportCustomerPdf = async () => {
  setspinnerTrans(true);

  try {
    const response = await getDataWithToken(
      `${showLead}?page=1
      &page_length=10000
      &search=${searchKeyword || ""}
      &stage=${isStatus || ""}
      &user_id=${isUser || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`
    );

    const doc = new jsPDF({
      orientation: "landscape",
    });

    const rows = response.data.data.map((e, index) => [
      index + 1,
      e.lead_id || "",
      e.name || "",
      e.phone || "",
      e.product_name || "",
      e.stage || "",
      e.assigned_user_name || "",
      e.expected_value || "",
      e.created_at || "",
    ]);

    autoTable(doc, {
      head: [[
        "Sl",
        "Lead ID",
        "Name",
        "Mobile",
        "Product",
        "Status",
        "Assigned To",
        "Expected Value",
        "Created On",
      ]],
      body: rows,
      startY: 20,
      styles: {
        fontSize: 8,
      },
    });

    doc.save("lead_report.pdf");
  } catch (error) {
    console.log("PDF Error:", error);
  } finally {
    setspinnerTrans(false);
  }
};
const exportCustomerExcel = async () => {
  setspinnerTrans(true);

  try {
    const response = await getDataWithToken(
      `${showLead}?page=1
      &page_length=10000
      &search=${searchKeyword || ""}
      &stage=${isStatus || ""}
      &user_id=${isUser || ""}
      &start_date=${formatStartDate || ""}
      &end_date=${formatEndDate || ""}
      &sort_by=${sortConfig.column || ""}
      &sort_order=${sortConfig.order || ""}`
    );

    const dataToExport = response.data.data.map((e) => ({
      Lead_ID: e.lead_id,
      Name: e.name,
      Mobile: e.phone,
      Product: e.product_name,
      Status: e.stage,
      Assigned_To: e.assigned_user_name,
      Expected_Value: e.expected_value,
      Created_On: e.created_at,
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Lead Data");

    XLSX.writeFile(wb, "lead_report.xlsx");
  } catch (error) {
    console.log(error);
  } finally {
    setspinnerTrans(false);
  }
};
  const ActionCell = ({ row }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const handleEditClick = () => {
      navigate(
        `${process.env.PUBLIC_URL}/lead-manage/editEnquiry?id=${row.id}`,
      );
    };
    const deleteEnquiryData = (row) => {
      SweetAlert.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this enquiry!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          setspinnerTrans(true);

          try {
            const deleteRes = await postDataWithToken(deleteEnquiry, {
              enquiry_id: row.id,
            });

            if (deleteRes?.data?.status === true) {
              SweetAlert.fire(
                "Deleted!",
                "Enquiry has been deleted.",
                "success",
              );

              toast.success(deleteRes?.data?.message);

              fetchLeads(currentPage);
            } else {
              toast.error(deleteRes?.data?.message || "Something went wrong");
            }
          } catch (error) {
            toast.error("Something went wrong");
          } finally {
            setspinnerTrans(false);
          }
        }
      });
    };

    const handleView = () => {
      navigate(
        `${process.env.PUBLIC_URL}/lead-manage/enquiry-details?id=${row.id}`,
      );
    };

    return (
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
        <DropdownToggle
          color="#00000"
          style={{ fontSize: "14px", zIndex: 1000 }}
        >
          <i className="fa fa-ellipsis-v"></i>
        </DropdownToggle>

        <DropdownMenu container="body">
          <DropdownItem style={toggleStyle} onClick={handleView}>
            View
          </DropdownItem>

          <DropdownItem style={toggleStyle} onClick={handleEditClick}>
            Edit
          </DropdownItem>
          <DropdownItem
            style={{
              padding: "10px 20px",
              color: "red",
              opacity: "0.8",
              fontSize: "14px",
              margin: "0",
            }}
            onClick={() => deleteEnquiryData(row)}
          >
            Delete{" "}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  };

  return (
    <Fragment>
      {spinnerTrans && <Transparentspinner />}

      <Breadcrumbs
        mainTitle="Leads List"
        parent="Lead Manager"
        title="Leads List"
      />
      <Widgets details={staticwidgets} />
      <Card>
        <CardHeader
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <H3>Leads List</H3>

          <div className="d-flex gap-2">
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle
                className="btn btn-primary"
                color="#fff"
                style={{ fontSize: "14px", zIndex: 1000 }}
              >
                Export <i className="icofont icofont-arrow-up"></i>
              </DropdownToggle>

              <DropdownMenu container="body">
                <DropdownItem style={toggleStyle} onClick={exportCustomerExcel}>
                  Excel
                </DropdownItem>

                <DropdownItem style={toggleStyle} onClick={exportCustomerPdf}>
                  PDF
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </CardHeader>

        <Form className="px-4 pb-2" onSubmit={handleFilter}>
          <Row className="g-3 align-items-center">
            <Col sm="12" md="3">
              <input
                className="form-control"
                value={tempSearch}
                onChange={(e) => setTempSearch(e.target.value)}
                placeholder={Search}
              />
            </Col>

            <Col sm="12" md="5" lg="3" className="form-element">
              <div style={{ position: "relative", zIndex: 2 }}>
                <DatePicker
                  className="form-control digits w-100"
                  selectsRange
                  startDate={tempStartDate}
                  endDate={tempEndDate}
                  onChange={(update) => {
                    setTempDateRange(update);
                  }}
                  isClearable={startDate ? true : false}
                  monthsShown={2}
                  popperPlacement="bottom"
                  calendarClassName="parallel-calendar"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select Date Range"
                />
              </div>
            </Col>
            <Col sm="12" md="2">
              <select
                value={tempUser}
                onChange={(e) => setTempUser(e.target.value)}
                className="form-control"
              >
                <option value="">Assigned User</option>

                {users?.map((item) => (
                  <option key={item.user_id} value={item.id}>
                    {item.first_name}
                  </option>
                ))}
              </select>
            </Col>

            <Col sm="12" md="2">
              <select
                value={tempStatus}
                onChange={(e) => setTempStatus(e.target.value)}
                className="form-control"
              >
                <option value="">Status</option>

                {enquiryStatusOptions?.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
            </Col>

            <Col sm="12" md="2">
              <Btn attrBtn={{ color: "primary" }} type="submit">
                {Filter}
              </Btn>
            </Col>
          </Row>
        </Form>

        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              pagination
              paginationServer
              columns={leadsColumns}
              data={customerLists}
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              onSort={handleSort}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              sortServer
              fixedHeader
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default LeadList;
